import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import ArrowDecor from "../../img/decor/arrow-decor.webp";
import AboutImg from "../../img/about/about_img.webp";


function EbAutOne({ ebautData }) {

    //console.log(ebautData);

    return (
        <>
            {
                ebautData ?
                    <section className="eut-abot relative mb-14 lg:py-[105px] md:border-t md:border-t-black" id="ebaut">
                        <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">

                            <div className="md:flex md:gap-[24px] md:justify-center xl:gap-[48px]">

                                <div className="mb-[20px] md:mb-0 md:w-1/2 md:max-w-[660px]">
                                    <h2 className="lg:text-[40px] text-[30px]
                                     text-[#00007c] font-black leading-[1.15] uppercase mb-4 xl:mb-[50px]">GET BUSINESS FESTIVAL</h2>
                                    <p className="mb-4 md:max-w-[616px] md:leading-[1.3] sm:text-[20px] text-[16px]">Щорічний великий фестиваль для малого та середнього бізнесу під егідою Dilo.ua</p>
                                    <p className="mb-4 sm:text-[20px] text-[16px]">Через поточну безпекову ситуацію в Україні та ускладнене пересування містом ми переносимо проведення GET Business Festival на 2027 рік.</p>

                                    <p className="mb-4 sm:text-[20px] text-[16px]">Ми щиро сподівались зустрітися з вами цього року, однак за нинішніх обставин безпека всіх учасників і команди залишається нашим головним пріоритетом.</p>

                                    <p className="mb-4 sm:text-[20px] text-[16px]">Усі придбані квитки підлягають повному поверненню. Щоб оформити повернення, будь ласка, напишіть нам на tickets@ekonomika.ua.</p>

                                    <p className="sm:text-[20px] text-[16px]"><b>Дякуємо за розуміння, довіру і підтримку!</b></p>
                                </div>

                                <div className="md:max-w-[860px] md:w-full">
                                    <div className="mb-[20px] xl:mb-[40px]">
                                        <img src={AboutImg} alt="About" className="block w-full" />
                                    </div>


                                    <div className="flex justify-between gap-[clamp(20px,calc(20px+34*((100vw-768px)/1152)),60px)]">
                                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                                " />
                                            <div className="flex flex-col">
                                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),60px)] leading-tight uppercase">1500+</h3>
                                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none">учасників</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                                " />
                                            <div className="flex flex-col">
                                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),60px)] leading-tight uppercase">90+</h3>
                                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none">спікерів</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                                " />
                                            <div className="flex flex-col">
                                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),60px)] leading-tight uppercase">3</h3>
                                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none text-nowrap">тематичні сцени</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>
                    </section> : ''
            }
        </>
    )
}

export default EbAutOne